import Bar from "./Bar";

export default Bar;



// WEBPACK FOOTER //
// ./src/components/Bar/index.ts